"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getUCS2Position(text, utf16index) {
    let utf16length = 0;
    let length = 0;
    for (let ch of text) {
        utf16length++;
        length += ch.length;
        if (utf16index === utf16length) {
            break;
        }
    }
    return length;
}
exports.default = getUCS2Position;
//# sourceMappingURL=getUCS2Position.js.map